import { createFeatureSelector } from "@ngrx/store";

export const FEATURE_KEY = "message-context";

export const selectContext = createFeatureSelector(FEATURE_KEY);
